export default __webpack_public_path__ + "static/media/snow.97ca2f1a.jpg";